




















































import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import MatchPrincipalAccordionTable from "@/components/Agents/MatchPrincipalAccordionTable.vue";
import ProductMixin from "@/mixins/http/Agents/Product";
import { AgentModuleConfiguration } from "@/models";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import ToastInvoker from "@/utils/ToastInvoker";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import ClientEntityWithHierarchyInterface from "@/models/Agents/Interfaces/ClientEntityWithHierarchyInterface";
import { NotificationBadgeGroups } from "@/components/Agents/NotificationBadge.vue";

@Component({
  components: {
    MatchPrincipalAccordionTable,
    MultiLevelSelect,
  },
})
export default class MatchProductSelectPrincipalAccordion extends Mixins(
  ProductMixin
) {
  @Prop() readonly productName!: string;
  @Prop() readonly agentModuleConfiguration!: AgentModuleConfiguration;

  @Getter("profile") readonly profile!: AdcontrolProfile;

  @Action("notificationsGroups/reload")
  readonly reloadNotificationForGroup!: (
    group: NotificationBadgeGroups
  ) => void;

  state: "opened" | "closed" = "closed";
  selectedProductId: string | null = null;
  options: any[] = [];
  loading = false;
  productsWithoutPrincipal: ClientEntityWithHierarchyInterface[] = [];
  resolved = false;

  @Watch("selectedProductId")
  onProductIdChanged(value: number) {
    const selectedProduct = this.productsWithoutPrincipal.find(
      (product) => product.id === value
    );

    if (!selectedProduct) return;

    this.productsWithoutPrincipal = this.productsWithoutPrincipal.map(
      (product) => {
        product.principalId = selectedProduct.id;
        return product;
      }
    );
  }

  async toggleState() {
    if (this.isResolved()) return;

    if (this.state == "opened" && !this.isResolved()) {
      this.state = "closed";
      return;
    }

    this.state = "opened";
    this.loading = true;
    try {
      const products = await this.getProductsWithHierarchy(this.profile.slug, {
        "filter[name]": this.productName,
        "page[size]": "all",
        include:
          "*.principal_agent_company,current_agent_company_agent_associations.*,current_agency",
      });

      this.productsWithoutPrincipal = products.map((el) => {
        return {
          id: el.id,
          name: el.name,
          term: el.name,
          currentAgentCompanyAgentAssociations:
            el.currentAgentCompanyAgentAssociations ?? [],
          currentAgency: el.currentAgency,
          currentAgentCompanyAssociation: el.currentAgentCompanyAssociation,
          principalId: el.principalProductId,
        };
      });

      this.options = this.productsWithoutPrincipal.map((product) => {
        return {
          id: product.id,
          text: product.id,
        };
      });
    } catch (error) {
      ToastInvoker.errorToast(
        "Errore durante il caricamento dei prodotti.",
        error
      );
    } finally {
      this.loading = false;
    }
  }

  async onSave() {
    if (!this.selectedProductId) {
      ToastInvoker.errorToast("Seleziona un prodotto prima di salvare.", null);
      return;
    }
    this.loading = true;
    try {
      await this.multipleAssignPrincipal(
        this.productsWithoutPrincipal.map((product) => product.id as number),
        this.profile?.slug || "",
        this.selectedProductId,
        "multiple_assign_principal"
      );
      ToastInvoker.successToast("Salvataggio effettuato con successo.");
      this.resolved = true;
      this.$emit("principal-product-solved");
      this.reloadNotificationForGroup(NotificationBadgeGroups.Products);
    } catch (error) {
      ToastInvoker.errorToast("Errore durante il salvataggio.", error);
    } finally {
      this.loading = false;
    }
  }

  isResolved() {
    return this.resolved;
  }

  hideWhenResolved() {
    return this.isResolved() ? "group-resolved" : "";
  }
}
